import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { forkJoin } from 'rxjs';
import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CentToEurDisplayDirective } from '@/directives/cent-to-eur-display.directive';
import { TicketPaperComponent } from '@/pages/tickets/ticket-receipt/ticket-paper.component';

/**
 * `/cash-closing/print/:id`: a single 80mm thermal receipt with one line per ticket of the
 * closing's period (number, payment method, subtotal, total) followed by the closing totals.
 */
@Component({
  selector: 'app-cash-closing-print',
  templateUrl: './cash-closing-print.component.html',
  imports: [TicketPaperComponent, CentToEurDisplayDirective, DatePipe],
})
export class CashClosingPrintComponent implements OnInit {

  public closing: any = null;
  public tickets: any[] = [];
  public company: any = {};
  public error = false;

  private paymentMethods: Record<string, string> = {
    efectivo: 'Efectivo',
    tarjeta: 'Tarjeta',
    mixto: 'Mixto',
    bizum: 'Bizum',
  };

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id')!;

    forkJoin({
      closing: this.apiService.getById(Urls.urls.cashClosings, id),
      tickets: this.apiService.getPetition(`${Urls.urls.cashClosings}/${id}/tickets`),
      selectors: this.apiService.getSelectors(Urls.urls.selectors, { companies: {} }),
    }).subscribe({
      next: ({ closing, tickets, selectors }: any) => {
        this.closing = closing;
        this.tickets = tickets.list || [];
        this.company = selectors.companies?.[0] || {};
        this.cdr.detectChanges();
        window.print();
      },
      error: (error: any) => {
        console.error('ERROR al obtener el cierre de caja. ' + error);
        this.error = true;
        this.cdr.detectChanges();
      },
    });
  }

  paymentLabel(method: string | null): string {
    return method ? (this.paymentMethods[method] ?? method) : '—';
  }
}
